// customers feedback actions
export const CUSTOMERS_FEEDBACK_PAGE_REQUEST =
  'CUSTOMERS_FEEDBACK_PAGE_REQUEST';
export const CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST =
  'CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST';
export const CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK =
  'CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK';

// Filter feedback by date constants
export const CUSTOMERS_FEEDBACK_CHANGE_DATE = 'CUSTOMERS_FEEDBACK_CHANGE_DATE';

// feedback detail actions
export const CUSTOMERS_FEEDBACK_MESSAGES_REQUEST =
  'CUSTOMERS_FEEDBACK_MESSAGES_REQUEST';
export const CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES =
  'CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES';
export const CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST =
  'CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST';
export const CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY =
  'CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY';
export const CUSTOMERS_FEEDBACK_RECEIPT_REQUEST =
  'CUSTOMERS_FEEDBACK_RECEIPT_REQUEST';
export const CUSTOMERS_FEEDBACK_SET_RECEIPT = 'CUSTOMERS_FEEDBACK_SET_RECEIPT';
export const CUSTOMERS_FEEDBACK_ON_CLICK_ROW = `CUSTOMERS_FEEDBACK_ON_CLICK_ROW`;

export const CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE =
  'CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE';
export const CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE =
  'CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE';
